export default __webpack_public_path__ + "static/media/gallery_02.122be27d.jpg";